import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "chart-lel chart-box box" }
const _hoisted_2 = { class: "chart-header" }
const _hoisted_3 = { class: "chart-title" }
const _hoisted_4 = { class: "title is-size-5 mb-0" }
const _hoisted_5 = { class: "chart-actions" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", { class: "button is-light is-small is-rounded mr-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "mdi is-size-5 mdi-help-circle-outline" })
], -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "mdi is-size-5 mdi-reload" }, null, -1 /* HOISTED */)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "chart-content" }
const _hoisted_10 = { ref: "chart" }
const _hoisted_11 = { class: "chart-content center" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-smoke-detector-off-outline is-size-3" }, null, -1 /* HOISTED */)
const _hoisted_13 = { class: "is-size-5" }
const _hoisted_14 = { class: "chart-content center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_popover = _resolveComponent("n-popover")!
  const _component_n_spin = _resolveComponent("n-spin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('advanced_view.lel_chart.title')), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_n_popover, {
          placement: "bottom-end",
          trigger: "hover"
        }, {
          trigger: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_n_popover, {
          placement: "bottom-end",
          trigger: "hover"
        }, {
          trigger: _withCtx(() => [
            _createElementVNode("button", {
              class: "button is-light is-small is-rounded",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.chart.resetZoom()))
            }, _hoisted_8)
          ]),
          default: _withCtx(() => [
            _createTextVNode(" " + _toDisplayString(_ctx.$t('chart.reset')), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_9, [
      _createElementVNode("canvas", _hoisted_10, null, 512 /* NEED_PATCH */)
    ], 512 /* NEED_PATCH */), [
      [_vShow, _ctx.station && _ctx.measures?.length]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_11, [
      _hoisted_12,
      _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('chart_network.no_data')), 1 /* TEXT */)
    ], 512 /* NEED_PATCH */), [
      [_vShow, _ctx.station && _ctx.measures?.length === 0]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_14, [
      _createVNode(_component_n_spin, { size: "large" })
    ], 512 /* NEED_PATCH */), [
      [_vShow, !_ctx.station || !_ctx.measures]
    ])
  ]))
}